module.exports = __webpack_public_path__ + "img/fapiao2.0893f920.png";